/**
 * Parse GSMA LPA string: LPA:1$<smdpAddress>$<activationCode>[$<confirmationCode>]
 */
export function parseLpaString(lpa) {
  if (!lpa || typeof lpa !== 'string') {
    return null
  }

  const trimmed = lpa.trim()
  if (!trimmed) {
    return null
  }

  const standardMatch = trimmed.match(/^LPA:1\$([^$]+)\$([^$]+)(?:\$([^$]+))?$/i)
  if (standardMatch) {
    return {
      smdpAddress: standardMatch[1],
      activationCode: standardMatch[2],
      confirmationCode: standardMatch[3] || null
    }
  }

  const parts = trimmed.split('$')
  if (parts.length >= 3) {
    const smdpAddress = parts[1]?.trim()
    const activationCode = parts[2]?.trim()
    const confirmationCode = parts[3]?.trim() || null
    if (smdpAddress && activationCode) {
      return { smdpAddress, activationCode, confirmationCode }
    }
  }

  return null
}
